import api from './api';

export interface KanbanColuna {
  id: string;
  empresaId: string;
  titulo: string;
  cor: string | null;
  tipo: string;
  ordem: number;
  minimizada: boolean;
  dataCriacao: string;
}

export interface KanbanCampo {
  id: string;
  empresaId: string;
  ticketId: string;
  campoLabel: string;
  campoTipo: string;
  valor: string | null;
  opcoes: string | null;
}

export interface KanbanCampoDefinicao {
  id: string;
  empresaId: string;
  campoLabel: string;
  campoTipo: string;
  opcoes: string | null;
  ordem: number;
}

export interface KanbanTicket {
  id: string;
  protocolo: string;
  status: string;
  kanbanColunaId: string | null;
  prioridade: string | null;
  assunto: string | null;
  fixada: boolean;
  dataAtualizacao: string;
  dataCriacao: string;
  nome: string;
  avatar: string | null;
  isGroup: boolean;
  telefone: string;
  contatoId: string;
  contato: any;
  atendente: { id: string; nome: string; avatarUrl?: string } | null;
  instancia: { id: string; nome: string; statusConexao: string } | null;
  fila: any;
  ticketTags: Array<{ tagId: string; tag: { id: string; titulo: string; cor?: string; prioridade?: string } }>;
  ultimaMensagem: { conteudo?: string; timestamp: string; remetenteTipo?: string; tipo?: string } | null;
  naoLidas: number;
}

export interface KanbanTicketPage {
  data: KanbanTicket[];
  total: number;
  hasMore: boolean;
}

export const kanbanService = {
  listarColunas: () => api.get<{ data: KanbanColuna[] }>('/kanban/colunas'),
  
  criarColuna: (data: { titulo: string; cor?: string }) =>
    api.post<{ data: KanbanColuna }>('/kanban/colunas', data),
  
  atualizarColuna: (id: string, data: { titulo?: string; cor?: string; minimizada?: boolean; ordem?: number }) =>
    api.put<{ data: KanbanColuna }>(`/kanban/colunas/${id}`, data),
  
  excluirColuna: (id: string) => api.delete(`/kanban/colunas/${id}`),
  
  reordenarColunas: (colunas: Array<{ id: string; ordem: number }>) =>
    api.put<{ data: KanbanColuna[] }>('/kanban/colunas/reordenar', { colunas }),
  
  listarTickets: (search?: string) =>
    api.get<{ data: KanbanTicket[] }>('/kanban/tickets', { params: search ? { search } : {} }),
  
  moverTicket: (id: string, data: { kanbanColunaId?: string | null; status?: string }) =>
    api.put<{ data: any }>(`/kanban/tickets/${id}/mover`, data),
  
  listarCampos: (ticketId: string) =>
    api.get<{ data: KanbanCampo[] }>(`/kanban/campos/${ticketId}`),
  
  upsertCampo: (data: { ticketId: string; campoLabel: string; campoTipo: string; valor?: string; opcoes?: string }) =>
    api.post<{ data: KanbanCampo }>('/kanban/campos', data),
  
  excluirCampo: (id: string) => api.delete(`/kanban/campos/${id}`),
  
  criarNota: (data: { ticketId: string; conteudo: string }) =>
    api.post<{ data: any }>('/kanban/notas', data),

  listarDefinicoes: () =>
    api.get<{ data: KanbanCampoDefinicao[] }>('/kanban/campos-definicao'),

  criarDefinicao: (data: { campoLabel: string; campoTipo: string; opcoes?: string }) =>
    api.post<{ data: KanbanCampoDefinicao }>('/kanban/campos-definicao', data),

  atualizarDefinicao: (id: string, data: { campoLabel?: string; campoTipo?: string; opcoes?: string }) =>
    api.put<{ data: KanbanCampoDefinicao }>(`/kanban/campos-definicao/${id}`, data),

  excluirDefinicao: (id: string) => api.delete(`/kanban/campos-definicao/${id}`),

  reordenarDefinicoes: (definicoes: Array<{ id: string; ordem: number }>) =>
    api.put<{ data: KanbanCampoDefinicao[] }>('/kanban/campos-definicao/reordenar', { definicoes }),

  listarTicketsPorColuna: (colunaId: string, opts?: { search?: string; limit?: number; offset?: number }) =>
    api.get<KanbanTicketPage>('/kanban/tickets-por-coluna', { params: { colunaId, ...opts } }),

  contarTicketsPorColunas: () =>
    api.get<{ data: Record<string, number> }>('/kanban/tickets-count-por-colunas'),

  fixarDesfixarTicket: (id: string) =>
    api.patch<{ data: any }>(`/kanban/tickets/${id}/fixar`),

  reordenarTickets: (tickets: Array<{ id: string; ordem: number }>) =>
    api.put<{ data: any }>('/kanban/tickets/reordenar', { tickets }),
};
